import React, { useEffect, useState } from "react";
import styles from "./compare.module.css";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Avatar from "@mui/material/Avatar";
import Image from "../../utils/assets/images.jpg";
import Chart from "components/UI/Chart";
import { ReactComponent as Oxy } from "../../utils/assets/Path.svg";
import { ReactComponent as Oxy2 } from "../../utils/assets/Path2.svg";
import { ReactComponent as Oxy3 } from "../../utils/assets/Path3.svg";
import { ReactComponent as Oxy4 } from "../../utils/assets/Path4.svg";
import { ReactComponent as Oxy5 } from "../../utils/assets/path5.svg";
import { ReactComponent as Oxy6 } from "../../utils/assets/path6.svg";
import { ReactComponent as Oxy7 } from "../../utils/assets/Path1.svg";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import Jsonpack from "jsonpack";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export default function ViewUser() {
  const axios = useAxiosPrivate();

  let navigate = useNavigate();
  const location = useLocation();
  const item = location.state;

  function handleClick(event) {
    event.preventDefault();
    navigate("/dashboard");
  }

  function handleClick1(event) {
    event.preventDefault();
    navigate(-1);
  }

  // eslint-disable-next-line
  const [members, setMembers] = useState([]);
  const [user, setUser] = useState([]);
  const [fData, setFData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [history, setHistory] = useState("");
  const [value, setValue] = useState(
    new Date(new Date() - 3 * 60000).toString()
  );
  const [value1, setValue1] = useState(new Date().toString());
  const handleChange = (newValue) => {
    setValue(newValue.toString());
  };

  const handleChange1 = (newValue) => {
    setValue1(newValue.toString());
  };
  const getHistory = async () => {
    const { data } = await axios.post("/team/historical_data", {
      user_id: item.user_id,
      date_from: value,
      date_to: value1,
    });
    const json = Jsonpack.unpack(data.data);
    setHistory(json);
  };
  const loadData = async () => {
    const { data } = await axios.get(
      "/team/dashboard?page=1&page_size=10&order=asc"
    );
    setMembers(data.data);
    const users = data.data.map((user) => {
      return user.user_id;
    });
    setUser(users);
    getData();
    getHistory();
  };
  const getData = async () => {
    if (user.length > 0 && fromDate === "") {
      const { data } = await axios.post("/team/data", {
        only_updates: false,
        user_ids: user,
      });
      const json = Jsonpack.unpack(data.data);
      setFData(json);

      const results = Object.entries(json)
        // eslint-disable-next-line
        .map((item) => {
          if (item[1].length) {
            if (item[1][item.length - 1]?.reading_time) {
              return new Date(item[1][item.length - 1].reading_time);
            }
          }
        })
        .filter((record) => record);

      if (results.length) {
        setFromDate(new Date(Math.max(...results)).toString());
      }
    } else if (user.length > 0 && fromDate !== "") {
      const { data } = await axios.post("/team/data", {
        only_updates: true,
        user_ids: user,
        from_time: fromDate,
      });

      const json = Jsonpack.unpack(data.data);
      setFData(json);

      const results = Object.entries(json)
        // eslint-disable-next-line
        .map((item) => {
          if (item[1].length) {
            if (item[1][item.length - 1]?.reading_time) {
              return new Date(item[1][item.length - 1].reading_time);
            }
          }
        })
        .filter((record) => record);

      if (results.length) {
        setFromDate(new Date(Math.min(...results)).toString());
      }
    }
  };
  useEffect(() => {
    getHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, value1]);
  useEffect(() => {
    loadData();
    const interval = setInterval(() => {
      if (user.length > 0) {
        getData();
      }
    }, 4000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const breadcrumbs = [
    <p onClick={handleClick} className={styles.breadcrumbs}>
      Dashboard
    </p>,
    <p onClick={handleClick1} className={styles.breadcrumbs}>
      {location.state?.first_name}&nbsp; {location.state?.last_name}
    </p>,
    <p className={styles.breadcrumbs}>Compare View</p>,
  ];

  if (fData.length !== 0) {
    return (
      <div>
        <div className={styles.containerMain}>
          <div className={styles.tab}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
          </div>
        </div>
        <div className={styles.containerMain}>
          <div className={styles.header}>
            <div className={styles.inside}>
              <div className={styles.box}>
                <div className={styles.item2}>
                  {" "}
                  <Avatar
                    alt="Remy Sharp"
                    src={Image}
                    sx={{ width: 46, height: 46 }}
                  />
                </div>
                <div className={styles.item3}>
                  {" "}
                  <p className={styles.tdText}>{"Jennifer Adamson"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.top}>
          <div className={styles.main}>
            <div className={styles.container}>
              <div className={styles.container2}>
                <div className={styles.inside2}>
                  <p className={styles.tdText}>{"Live Reading"}</p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "3px solid #A6CEE3",
                        width: "1.5rem",
                        marginRight: "5px",
                      }}
                    ></div>
                    <p className={styles.tittleText}>SpO2 (%)</p>
                    <div
                      style={{
                        borderBottom: "3px dashed #1F78B4",
                        width: "1.5rem",
                        marginRight: "5px",
                      }}
                    ></div>
                    <p className={styles.tittleText}>Pulse Rate (bpm)</p>
                  </div>
                  <div>
                    <Chart fData={fData[String(item?.user_id)]} height={200} />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.container}>
              <div className={styles.container2}>
                <div className={styles.inside2}>
                  <p className={styles.tdText}>{"Live Measurements"}</p>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Oxygen"}</p>
                      <div className={styles.box3}>
                        <Oxy style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number}>
                          {" "}
                          {fData[String(item?.user_id)][
                            fData[String(item?.user_id)]?.length - 1
                          ]?.spo2
                            ? fData[String(item?.user_id)][
                                fData[String(item?.user_id)]?.length - 1
                              ]?.spo2
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"SPO₂"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Pulse Rate"}</p>
                      <div className={styles.box3}>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <Oxy2 style={{ width: "1.67rem", padding: 0 }} />
                          <Oxy7 style={{ width: "1.67rem", padding: 0 }} />
                        </div>
                        <p className={styles.number2}>
                          {fData[String(item?.user_id)][
                            fData[String(item?.user_id)]?.length - 1
                          ]?.heart_rate
                            ? fData[String(item?.user_id)][
                                fData[String(item?.user_id)]?.length - 1
                              ]?.heart_rate
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"bpm"}</p>
                      </div>
                    </div>
                  </div>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Altitude"}</p>
                      <div className={styles.box3}>
                        <Oxy3 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>
                          {fData[String(item?.user_id)][
                            fData[String(item?.user_id)]?.length - 1
                          ]?.altitude
                            ? fData[String(item?.user_id)][
                                fData[String(item?.user_id)]?.length - 1
                              ]?.altitude
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"feet"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Air Quality Index"}</p>
                      <div className={styles.box3}>
                        <Oxy4 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>
                          {fData[String(item?.user_id)][
                            fData[String(item?.user_id)]?.length - 1
                          ]?.air_quality
                            ? fData[String(item?.user_id)][
                                fData[String(item?.user_id)]?.length - 1
                              ]?.air_quality
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"moderate"}</p>
                      </div>
                    </div>
                  </div>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Humidity"}</p>
                      <div className={styles.box3}>
                        <Oxy5 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>
                          {fData[String(item?.user_id)][
                            fData[String(item?.user_id)]?.length - 1
                          ]?.humidity
                            ? fData[String(item?.user_id)][
                                fData[String(item?.user_id)]?.length - 1
                              ]?.humidity
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"%"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Barometric Pressure"}</p>
                      <div className={styles.box3}>
                        <Oxy6 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>
                          {fData[String(item?.user_id)][
                            fData[String(item?.user_id)]?.length - 1
                          ]?.biometric_pressure
                            ? fData[String(item?.user_id)][
                                fData[String(item?.user_id)]?.length - 1
                              ]?.biometric_pressure
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"in. HG"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.top}>
          <div className={styles.main}>
            <div className={styles.container}>
              <div className={styles.container2}>
                <div className={styles.inside2}>
                  <p className={styles.tdText}>{"History Reading"}</p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "1rem",
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        label="Start Time"
                        value={value}
                        onChange={handleChange}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        label="End Time"
                        value={value1}
                        maxDateTime={new Date()}
                        onChange={handleChange1}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "3px solid #A6CEE3",
                        width: "1.5rem",
                        marginRight: "5px",
                      }}
                    ></div>
                    <p className={styles.tittleText}>SpO₂ (%)</p>
                    <div
                      style={{
                        borderBottom: "3px dashed #1F78B4",
                        width: "1.5rem",
                        marginRight: "5px",
                      }}
                    ></div>
                    <p className={styles.tittleText}>Pulse Rate (bpm)</p>
                  </div>
                  <Chart fData={history} height={200} />
                </div>
              </div>
            </div>
            <div className={styles.container}>
              <div className={styles.container2}>
                <div className={styles.inside2}>
                  <p className={styles.tdText}>{"History Measurements"}</p>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Oxygen"}</p>
                      <div className={styles.box3}>
                        <Oxy style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number}>
                          {history?.length !== 0
                            ? history[history.length - 1].spo2
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"SPO₂"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Pulse Rate"}</p>
                      <div className={styles.box3}>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <Oxy2 style={{ width: "1.67rem", padding: 0 }} />
                          <Oxy7 style={{ width: "1.67rem", padding: 0 }} />
                        </div>
                        <p className={styles.number2}>
                          {history?.length !== 0
                            ? history[history.length - 1].heart_rate
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"bpm"}</p>
                      </div>
                    </div>
                  </div>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Altitude"}</p>
                      <div className={styles.box3}>
                        <Oxy3 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>
                          {history?.length !== 0
                            ? history[history.length - 1].altitude
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"feet"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Air Quality Index"}</p>
                      <div className={styles.box3}>
                        <Oxy4 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>
                          {history?.length !== 0
                            ? history[history.length - 1].air_quality
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"moderate"}</p>
                      </div>
                    </div>
                  </div>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Humidity"}</p>
                      <div className={styles.box3}>
                        <Oxy5 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>
                          {history?.length !== 0
                            ? history[history.length - 1].humidity
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"%"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Barometric Pressure"}</p>
                      <div className={styles.box3}>
                        <Oxy6 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>
                          {history?.length !== 0
                            ? history[history.length - 1].biometric_pressure
                            : "--"}
                        </p>
                        <p className={styles.divText}>{"in. HG"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <div className={styles.containerMain}>
          <div className={styles.tab}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
          </div>
        </div>
        <div className={styles.containerMain}>
          <div className={styles.header}>
            <div className={styles.inside}>
              <div className={styles.box}>
                <div className={styles.item2}>
                  {" "}
                  <Avatar
                    alt="Remy Sharp"
                    src={Image}
                    sx={{ width: 46, height: 46 }}
                  />
                </div>
                <div className={styles.item3}>
                  {" "}
                  <p className={styles.tdText}>{"Jennifer Adamson"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.top}>
          <div className={styles.main}>
            <div className={styles.container}>
              <div className={styles.container2}>
                <div className={styles.inside2}>
                  <p className={styles.tdText}>{"Live Reading"}</p>
                  <p className={styles.tittleText}>SpO (%) Pulse Rate (bpm)</p>
                  {/* <Calender /> */}
                  {/*<Chart/>*/}
                </div>
              </div>
            </div>
            <div className={styles.container}>
              <div className={styles.container2}>
                <div className={styles.inside2}>
                  <p className={styles.tdText}>{"Live Measurements"}</p>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Oxygen"}</p>
                      <div className={styles.box3}>
                        <Oxy style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number}>{"--"}</p>
                        <p className={styles.divText}>{"SPO₂"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Pulse Rate"}</p>
                      <div className={styles.box3}>
                        <Oxy2 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>{"--"}</p>
                        <p className={styles.divText}>{"bpm"}</p>
                      </div>
                    </div>
                  </div>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Altitude"}</p>
                      <div className={styles.box3}>
                        <Oxy3 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>{"--"}</p>
                        <p className={styles.divText}>{"feet"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Air Quality Index"}</p>
                      <div className={styles.box3}>
                        <Oxy4 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>{"--"}</p>
                        <p className={styles.divText}>{"moderate"}</p>
                      </div>
                    </div>
                  </div>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Humidity"}</p>
                      <div className={styles.box3}>
                        <Oxy5 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>{"--"}</p>
                        <p className={styles.divText}>{"%"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Barometric Pressure"}</p>
                      <div className={styles.box3}>
                        <Oxy6 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>{"--"}</p>
                        <p className={styles.divText}>{"in. HG"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.top}>
          <div className={styles.main}>
            <div className={styles.container}>
              <div className={styles.container2}>
                <div className={styles.inside2}>
                  <p className={styles.tdText}>{"History Reading"}</p>
                  <p className={styles.tittleText}>SpO (%) Pulse Rate (bpm)</p>
                  {/*<Chart/>*/}
                </div>
              </div>
            </div>
            <div className={styles.container}>
              <div className={styles.container2}>
                <div className={styles.inside2}>
                  <p className={styles.tdText}>{"History Measurements"}</p>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Oxygen"}</p>
                      <div className={styles.box3}>
                        <Oxy style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number}>{"--"}</p>
                        <p className={styles.divText}>{"SPO₂"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Pulse Rate"}</p>
                      <div className={styles.box3}>
                        <Oxy2 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>{"--"}</p>
                        <p className={styles.divText}>{"bpm"}</p>
                      </div>
                    </div>
                  </div>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Altitude"}</p>
                      <div className={styles.box3}>
                        <Oxy3 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>{"--"}</p>
                        <p className={styles.divText}>{"feet"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Air Quality Index"}</p>
                      <div className={styles.box3}>
                        <Oxy4 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>{"--"}</p>
                        <p className={styles.divText}>{"moderate"}</p>
                      </div>
                    </div>
                  </div>
                  <div className={styles.boxNew}>
                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Humidity"}</p>
                      <div className={styles.box3}>
                        <Oxy5 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>{"--"}</p>
                        <p className={styles.divText}>{"%"}</p>
                      </div>
                    </div>

                    <div className={styles.box2}>
                      <p className={styles.divText}>{"Barometric Pressure"}</p>
                      <div className={styles.box3}>
                        <Oxy6 style={{ width: "1.67rem", height: "1.31rem" }} />
                        <p className={styles.number2}>{"--"}</p>
                        <p className={styles.divText}>{"in. HG"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
